//Loader
const SET_LOADER = "SET_LOADER";

//Side Menu
const IS_MENU_OPEN = "IS_MENU_OPEN";

//Toast Actions
const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
const SHOW_VALIDATION_ERROR_MESSAGE = "SHOW_VALIDATION_ERROR_MESSAGE";
const SHOW_DEFAULT_ERROR_MESSAGE = "SHOW_DEFAULT_ERROR_MESSAGE";

//Profile
const SET_MANAGER_DETAILS = "SET_MANAGER_DETAILS";
const SET_MANAGER_TOTAL_APP_COUNT = "SET_MANAGER_TOTAL_APP_COUNT";
const SET_UPDATED_PROFILEPHOTO = "SET_UPDATED_PROFILEPHOTO";
const SET_LASTLOGIN_DETAILS = "SET_LASTLOGIN_DETAILS";

///Std plan
const SET_CURRENT_STEP = "SET_CURRENT_STEP";
const SET_MAX_STEPS = "SET_MAX_STEPS";
const SET_MIN_STEPS = "SET_MIN_STEPS";
const SET_COUNTRY = "SET_COUNTRY";
const SET_CITY = "SET_CITY";
const SET_STATE = "SET_STATE";
const SET_PLAN_LINK = "SET_PLAN_LINK";
const SET_DEPARTMENT = "SET_DEPARTMENT";
const SET_SUPERVISOR_LIST = "SET_SUPERVISOR_LIST";
const SET_REGION = "SET_REGION";
const SET_JOB = "SET_JOB";
const SET_LOCATION = "SET_LOCATION";
const SET_CLIENT_INFO = "SET_CLIENT_INFO";
const SET_PREFFERED_LANG = "SET_PREFFERED_LANG";
const SET_IS_SEARCH = "SET_IS_SEARCH";
const SET_EMPLOYMENT_STATUS = "SET_EMPLOYMENT_STATUS";
const SET_CLIENT_INFO_BY_ID = "SET_CLIENT_INFO_BY_ID";
const SET_ATTACHMENT = "SET_ATTACHMENT";
const IS_ADDED = "IS_ADDED";
const SET_ERS_FORM_PDF = "SET_ERS_FORM_PDF";
const SET_STD_EMPLOYEE_STATEMENT = "SET_STD_EMPLOYEE_STATEMENT"
/** Modal Actions */
export const OPEN_SET_MODAL = "OPEN_SET_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_REMOVE_MODAL = "CLOSE_REMOVE_MODAL";

/** Attachment Actions   */
export const SET_ATTACHMENTS = "SET_ATTACHMENTS";
export const SET_TOTAL_ROWS = "SET_TOTAL_ROWS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const IS_CUSTOM_ATTACHMENT = "IS_CUSTOM_ATTACHMENT";

/** Ers application by ein **/
export const SET_CASE_DETAILS_BY_EIN = "SET_CASE_DETAILS_BY_EIN";

/*Manager Applicant  */
export const SET_EMPLOYEE_BY_MANAGER = "SET_EMPLOYEE_BY_MANAGER";
export const SET_FILTERED_EMPLOYEE_BY_MANAGER =
  "SET_FILTERED_EMPLOYEE_BY_MANAGER";
export const SET_ERS_TOTAL_ROWS = "SET_ERS_TOTAL_ROWS";
export const SET_ERS_CURRENT_PAGE = "SET_ERS_CURRENT_PAGE";
export const SET_ERS_PAGE_SIZE = "SET_ERS_PAGE_SIZE";
export const SET_ERS_CASE_DETAIL_BY_EIN = "SET_ERS_CASE_DETAIL_BY_EIN";
export const SET_CASESTATUS_TOTAL_ROWS = "SET_CASESTATUS_TOTAL_ROWS";
export const SET_CASESTATUS_CURRENT_PAGE = "SET_CASESTATUS_CURRENT_PAGE";
export const SET_CASESTATUS_PAGE_SIZE = "SET_CASESTATUS_PAGE_SIZE";
export const SET_SELECTED_CASE_DETAIL = "SET_SELECTED_CASE_DETAIL";
export const SET_IS_SELECTED_CASE = "SET_IS_SELECTED_CASE";

// Case Status
export const SET_CASE_STATUS = "SET_CASE_STATUS";
export const SET_CASE_STATUS_MODIFIED = "SET_CASE_STATUS_MODIFIED";
export const SET_CASE_STATUS_MODIFIED_CCM = "SET_CASE_STATUS_MODIFIED_CCM";
export const SET_FILTER_CASE_STATUS = "SET_FILTER_CASE_STATUS";

// Case ACMD Status
export const SET_ACMD_CASE_STATUS = "SET_CASE_STATUS";
export const SET_ACMD_CASE_STATUS_MODIFIED = "SET_CASE_STATUS_MODIFIED";
export const SET_ACMD_FILTER_CASE_STATUS = "SET_FILTER_CASE_STATUS";
export const SET_ACMD_CASESTATUS_TOTAL_ROWS = "SET_CASESTATUS_TOTAL_ROWS";
export const SET_ATTACHMENT_ACMD = "SET_ATTACHMENT_ACMD";

// Case CCM Status
export const SET_CCM_CASE_STATUS = "SET_CCM_CASE_STATUS";
export const SET_CCM_CASE_STATUS_MODIFIED = "SET_CCM_CASE_STATUS_MODIFIED";
export const SET_CCM_FILTER_CASE_STATUS = "SET_CCM_FILTER_CASE_STATUS";
export const SET_CCM_CASESTATUS_TOTAL_ROWS = "SET_CCM_CASESTATUS_TOTAL_ROWS";
export const SET_ATTACHMENT_CCM = "SET_ATTACHMENT_CCM";

/* Login actions */
export const IS_AUTHENTICATING = "IS_AUTHENTICATING";
export const IS_AUTHENTICATED = "IS_AUTHENTICATED";
export const IS_AUTHENTICATION_FAILED = "IS_AUTHENTICATION_FAILED";
export const IS_SESSION_VALID = "IS_SESSION_VALID";
export const SET_IS_PASSWORD_EXPIRED = "SET_IS_PASSWORD_EXPIRED"
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN"
export const SET_IS_LOGIN = "SET_IS_LOGIN"
export const SET_ON_LOGIN_MODALNOTIFICATION = "SET_ON_LOGIN_MODALNOTIFICATION"

/* Air actions */
const SET_AIR_CURRENT_STEP = "SET_AIR_CURRENT_STEP";
const SET_AIR_MAX_STEPS = "SET_AIR_MAX_STEPS";
const SET_AIR_MIN_STEPS = "SET_AIR_MIN_STEPS";
const SET_AIR_IS_ADDED = "SET_AIR_IS_ADDED";
const SET_AIR_FORM_PDF = "SET_AIR_FORM_PDF";
const SET_AIR_PENDING_APPLICATIONS = "SET_AIR_PENDING_APPLICATIONS";
const SET_AIR_EMPLOYEE_STATEMENT = "SET_AIR_EMPLOYEE_STATEMENT";

// Reports
const SET_REPORTS_DETAILS = "SET_REPORTS_DETAILS";
const SET_REPORTS = "SET_REPORTS";


/* Accomodation actions */
const SET_ACCOMODATION_CURRENT_STEP = "SET_ACCOMODATION_CURRENT_STEP";
const SET_ACCOMODATION_MAX_STEPS = "SET_ACCOMODATION_MAX_STEPS";
const SET_ACCOMODATION_MIN_STEPS = "SET_ACCOMODATION_MIN_STEPS";
const SET_ACCOMODATION_IS_ADDED = "SET_ACCOMODATION_IS_ADDED";
const SET_ACCOMODATION_FORM_PDF = "SET_ACCOMODATION_FORM_PDF";
const SET_ACCOMODATION_APPLICANTS = "SET_ACCOMODATION_APPLICANTS";
const SET_ACMD_STATEMENT = "SET_ACMD_STATEMENT";
const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
const SET_FILE_HISTORY = "SET_FILE_HISTORY";
const SET_MARQUEE_TEXT = "SET_MARQUEE_TEXT";

/* CCM actions */
const SET_CCM_CURRENT_STEP = "SET_CCM_CURRENT_STEP";
const SET_CCM_MAX_STEPS = "SET_CCM_MAX_STEPS";
const SET_CCM_MIN_STEPS = "SET_CCM_MIN_STEPS";
const SET_CCM_IS_ADDED = "SET_CCM_IS_ADDED";
const SET_CCM_FORM_PDF = "SET_CCM_FORM_PDF";
const SET_CCM_APPLICANTS = "SET_CCM_APPLICANTS";
const SET_CCM_STATEMENT = "SET_CCM_STATEMENT";

// Pagination Param
const SET_ACCOMODATION_PAGE_NO = "SET_ACCOMODATION_PAGE_NO";
const SET_ACCOMODATION_PAGE_SIZE = "SET_ACCOMODATION_PAGE_SIZE";
const SET_ACCOMODATION_PAGE_ROWS = "SET_ACCOMODATION_PAGE_ROWS";

// CCM Pagination Param
const SET_CCM_PAGE_NO = "SET_CCM_PAGE_NO";
const SET_CCM_PAGE_SIZE = "SET_CCM_PAGE_SIZE";
const SET_CCM_PAGE_ROWS = "SET_CCM_PAGE_ROWS";

/* Air applicants */
export const SET_AIR_EMPLOYEE_BY_MANAGER = "SET_AIR_EMPLOYEE_BY_MANAGER";
export const SET_AIR_TOTAL_ROWS = "SET_AIR_TOTAL_ROWS";
export const SET_AIR_CURRENT_PAGE = "SET_AIR_CURRENT_PAGE";
export const SET_AIR_PAGE_SIZE = "SET_AIR_PAGE_SIZE";
/* Company actions */
const SET_COMPANY_CURRENT_STEP = "SET_COMPANY_CURRENT_STEP";
const SET_COMPANY_MAX_STEPS = "SET_COMPANY_MAX_STEPS";
const SET_COMPANY_MIN_STEPS = "SET_COMPANY_MIN_STEPS";
const SET_COMPANY_ASSIGNED_LEVELS = "SET_COMPANY_ASSIGNED_LEVELS";
const SET_COMPANY_LEVEL_ITEMS = "SET_COMPANY_LEVEL_ITEMS";

//Notification actions
const SET_IS_NOTIFICATION_SHOWN = "SET_IS_NOTIFICATION_SHOWN";
const SET_PENDING_APPLICATIONS = "SET_PENDING_APPLICATIONS";
const SET_ON_SUBMIT = "SET_ON_SUBMIT"



//Notification actions
const SET_FILTER_APPLICATION_VALUES = "SET_FILTER_APPLICATION_VALUES";

// User Permissions
const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS"
const SET_USER_ROLES = "SET_USER_ROLES"
const SET_AUTH_USERS = "SET_AUTH_USERS"
const SET_AUTH_USER = "SET_AUTH_USER"
const IS_USER_SET = "IS_USER_SET"
const SET_TOTAL_RECORD_OF_USER_LIST = "SET_TOTAL_RECORD_OF_USER_LIST"
const SET_IS_USER_DELETE = "SET_IS_USER_DELETE"
const SET_COMPANY_LIST = "SET_COMPANY_LIST"
const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY"
const SET_DOMAIN_LIST = "SET_DOMAIN_LIST"
const SET_DOMAIN_FLAG = "SET_DOMAIN_FLAG"
const SET_DEPARTMENT_LIST = "SET_DEPARTMENT_LIST"
const SET_REGION_LIST = "SET_REGION_LIST"
const SET_BACKUP_USERS = "SET_BACKUP_USERS"
const SET_BACKUP_USERS_FLAG = "SET_BACKUP_USERS_FLAG"
const SET_COMPANY_SERVICES = "SET_COMPANY_SERVICES"
const SET_USER_COMPANY_SERVICES = "SET_USER_COMPANY_SERVICES"
const SET_ISBACKUP_ASSIGNED = "SET_ISBACKUP_ASSIGNED"
const SET_LEVEL_ITEM = "SET_LEVEL_ITEM"
const SET_SUCCESS_MESSAGE_FOR_BACKUP_USER_ASSIGNED = "SET_SUCCESS_MESSAGE_FOR_BACKUP_USER_ASSIGNED"
const OPEN_SIMPLE_MODAL_FOR_TERMINATION = "OPEN_SIMPLE_MODAL_FOR_TERMINATION"
const SET_SELECTED_DOMAIN_VALUES = "SET_SELECTED_DOMAIN_VALUES"
const RESET_SELECTED_DOMAIN_VALUES = "RESET_SELECTED_DOMAIN_VALUES"
const SET_REPORT_MODULES = "SET_REPORT_MODULES"

//forgot Password Actions
const IS_OTP_SEND = "IS_OTP_SEND"
const SET_OTP_DATA = "SET_OTP_DATA"

//My Applications Actions
const SET_MY_APPLICATIONS = "SET_MY_APPLICATIONS"
const SET_MY_APPLICATIONS_TOTALCOUNT = "SET_MY_APPLICATIONS_TOTALCOUNT"

const SET_MY_REPORT = "SET_MY_REPORT"

export default {
  SET_MY_REPORT,
  SET_REPORTS,
  SET_REPORTS_DETAILS,
  SET_LEVEL_ITEM,
  SET_FILTER_APPLICATION_VALUES,
  SET_IS_NOTIFICATION_SHOWN,
  SET_ACCOMODATION_APPLICANTS,
  SET_CCM_APPLICANTS,
  SET_AIR_PAGE_SIZE,
  SET_AIR_CURRENT_PAGE,
  SET_AIR_TOTAL_ROWS,
  SET_AIR_EMPLOYEE_BY_MANAGER,
  SET_COMPANY_CURRENT_STEP,
  SET_COMPANY_MAX_STEPS,
  SET_COMPANY_MIN_STEPS,
  SET_ACCOMODATION_CURRENT_STEP,
  SET_CCM_CURRENT_STEP,
  SET_ACCOMODATION_MAX_STEPS,
  SET_CCM_MAX_STEPS,
  SET_ACCOMODATION_MIN_STEPS,
  SET_CCM_MIN_STEPS,
  SET_ACCOMODATION_IS_ADDED,
  SET_CCM_IS_ADDED,
  SET_ACCOMODATION_FORM_PDF,
  SET_CCM_FORM_PDF,
  SET_ACMD_STATEMENT,
  SET_CCM_STATEMENT,
  SET_SUCCESS_MESSAGE,
  SET_FILE_HISTORY,
  SET_MARQUEE_TEXT,
  SET_AIR_CURRENT_STEP,
  SET_AIR_MAX_STEPS,
  SET_AIR_MIN_STEPS,
  SET_AIR_FORM_PDF,
  SET_AIR_IS_ADDED,
  SET_ERS_TOTAL_ROWS,
  SET_ERS_CURRENT_PAGE,
  SET_ERS_CASE_DETAIL_BY_EIN,
  SET_CASESTATUS_TOTAL_ROWS,
  SET_CASESTATUS_CURRENT_PAGE,
  SET_CASESTATUS_PAGE_SIZE,
  SET_SELECTED_CASE_DETAIL,
  SET_IS_SELECTED_CASE,
  SET_ERS_PAGE_SIZE,
  IS_SESSION_VALID,
  SET_IS_PASSWORD_EXPIRED,
  SET_AUTH_TOKEN,
  SET_IS_LOGIN,
  SET_ON_LOGIN_MODALNOTIFICATION,
  SET_LASTLOGIN_DETAILS,
  IS_AUTHENTICATION_FAILED,
  IS_AUTHENTICATED,
  IS_AUTHENTICATING,
  SET_FILTERED_EMPLOYEE_BY_MANAGER,
  SET_EMPLOYEE_BY_MANAGER,
  SET_CASE_STATUS,
  SET_ACMD_CASE_STATUS,
  SET_CCM_CASE_STATUS,
  SET_ACMD_CASE_STATUS_MODIFIED,
  SET_ACMD_FILTER_CASE_STATUS,
  SET_ATTACHMENT_ACMD,
  SET_ATTACHMENT_CCM,
  SET_CASE_DETAILS_BY_EIN,
  SET_CASE_STATUS_MODIFIED,
  SET_CASE_STATUS_MODIFIED_CCM,
  SET_FILTER_CASE_STATUS,
  IS_CUSTOM_ATTACHMENT,
  SET_PAGE_SIZE,
  SET_CURRENT_PAGE,
  SET_TOTAL_ROWS,
  SET_ATTACHMENTS,
  SET_ERS_FORM_PDF,
  SET_STD_EMPLOYEE_STATEMENT,
  IS_MENU_OPEN,
  SET_MANAGER_TOTAL_APP_COUNT,
  SET_UPDATED_PROFILEPHOTO,
  SET_MANAGER_DETAILS,
  IS_ADDED,
  SET_ATTACHMENT,
  SET_JOB,
  SET_CLIENT_INFO_BY_ID,
  SET_CLIENT_INFO,
  SET_SUPERVISOR_LIST,
  SET_DEPARTMENT,
  SET_REGION,
  SET_LOCATION,
  SET_IS_SEARCH,
  SET_LOADER,
  SET_PLAN_LINK,
  SET_CURRENT_STEP,
  SET_MAX_STEPS,
  SET_MIN_STEPS,
  SET_CITY,
  SET_COUNTRY,
  SET_STATE,
  SET_PREFFERED_LANG,
  SET_EMPLOYMENT_STATUS,
  SHOW_ERROR_MESSAGE,
  SHOW_SUCCESS_MESSAGE,
  SHOW_VALIDATION_ERROR_MESSAGE,
  SHOW_DEFAULT_ERROR_MESSAGE,
  SET_ACCOMODATION_PAGE_NO,
  SET_CCM_PAGE_NO,
  SET_ACCOMODATION_PAGE_SIZE,
  SET_CCM_PAGE_SIZE,
  SET_ACCOMODATION_PAGE_ROWS,
  SET_CCM_PAGE_ROWS,
  SET_CCM_PAGE_ROWS,
  SET_ACMD_CASESTATUS_TOTAL_ROWS,
  SET_AIR_PENDING_APPLICATIONS,
  SET_AIR_EMPLOYEE_STATEMENT,
  SET_PENDING_APPLICATIONS,
  SET_ON_SUBMIT,
  SET_USER_PERMISSIONS,
  SET_USER_ROLES,
  SET_AUTH_USERS,
  SET_AUTH_USER,
  IS_USER_SET,
  SET_TOTAL_RECORD_OF_USER_LIST,
  SET_IS_USER_DELETE,
  SET_COMPANY_LIST,
  SET_SELECTED_COMPANY,
  IS_OTP_SEND,
  SET_OTP_DATA,
  SET_DOMAIN_LIST,
  SET_DOMAIN_FLAG,
  SET_DEPARTMENT_LIST,
  SET_REGION_LIST,
  SET_BACKUP_USERS,
  SET_BACKUP_USERS_FLAG,
  SET_COMPANY_SERVICES,
  SET_USER_COMPANY_SERVICES,
  SET_ISBACKUP_ASSIGNED,
  SET_SUCCESS_MESSAGE_FOR_BACKUP_USER_ASSIGNED,
  OPEN_SIMPLE_MODAL_FOR_TERMINATION,
  SET_SELECTED_DOMAIN_VALUES,
  RESET_SELECTED_DOMAIN_VALUES,
  SET_REPORT_MODULES,
  SET_MY_APPLICATIONS,
  SET_MY_APPLICATIONS_TOTALCOUNT,
  SET_COMPANY_ASSIGNED_LEVELS,
  SET_COMPANY_LEVEL_ITEMS,
};
